<template>
  <page :title="displayTitle" :breadcrumb="breadcrumbRef">
    <v-layout column v-if="!noAction">
      <v-flex>
        <v-card>
          <v-list two-line subheader>
            <template v-for="(item) in menuRef.children">
              <v-list-tile :key="item.name" @click="launchApp(item.name, item.route)">
                <v-list-tile-action>
                  <v-icon v-if="item.icon">{{item.icon}}</v-icon>
                  <v-icon v-else>{{ item.route? 'mdi-launch' : 'mdi-folder'}}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ item.text }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>{{item.desc}}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action v-if="hasQuickLaunch">
                  <v-btn icon ripple @click.stop="toggleQuickLaunch(item.name)">
                    <v-icon color="primary">{{checkQuickLaunch(item.name) ? 'mdi-star' : 'mdi-star-outline'}}</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout column v-else>
      <v-flex>
        No Action is found for this menu option. Please contact the System Administrator for help.
      </v-flex>
    </v-layout>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import Routable from '@/mixins/routable'

export default {
  data() {
    return {
      displayTitle: '',
      menuRef: undefined,
      breadcrumbRef: [],
      // noAction is use to define menu with no children and is not a route link (basically a deadend)
      noAction: true
    }
  },
  computed: {
    ...mapGetters([
      'getInternalMenu',
      'derieveBreadcrumb'
    ]),
    hasQuickLaunch() {
      if (this.$store.state.widgets.quickLaunch.init === 1) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    id: {
      handler: 'handleRoute',
      immediate: true
    }
  },
  methods: {
    handleRoute() {
      if (this.id) {
        this.menuRef = this.getInternalMenu(this.id)
        if (this.menuRef) {
          if (this.menuRef.route) {
            // It is a routable menu
            this.$router.push({ name: this.menuRef.name })
          } else {
            // Set display title
            this.displayTitle = this.menuRef.text
            this.breadcrumbRef = this.derieveBreadcrumb(this.menuRef.key)
            if (this.menuRef.children) {
              this.noAction = false
            } else {
              // Reach here means no route no child
              this.noAction = true
            }
          }
        } else {
          // cannot find, push to 404
          this.$router.push({ name: 'notfound' })
        }
      }
    }
  },
  props: [
    'id'
  ],
  mixins: [
    Routable
  ]
}
</script>

<style>

</style>
